import * as types from "./mutation_types";

export default {
  [types.ASSISE_CREATE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.ASSISE_CREATE_TOGGLE_LOADING](state) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },

  [types.ASSISE_CREATE_SET_CREATED](state, created) {
    Object.assign(state, { created });
  },

  [types.ASSISE_CREATE_SET_VIOLATIONS](state, violations) {
    Object.assign(state, { violations });
  },

  [types.ASSISE_CREATE_SET_RETRIEVED](state, retrieved) {
    Object.assign(state, { retrieved });
  },

  [types.ASSISE_CREATE_RESET](state) {
    Object.assign(state, {
      created: false,
      error: "",
      isLoading: false,
      violations: null,
    });
  },
};
